import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextLandRo = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 ROTIRI GRATUITE"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['Bonus', 'ROTIRI']}
            className={cls.text}
        />
    )
}
